module.exports = __webpack_public_path__ + "media/images/flags/4x3/msr-c6877684a117d1987b48ec144424ef95.svg";